export default {
	load: {
		storeKey: "OrgunitAddress",
		params: ["orgunitAddressId"],
		type: "Entity.Data.Address",
		flags: "CD"
	},
	scheme: {
		_id: {
			relation: "@addressId"
		},
		region: {
			codeList: {_id: "region"}
		},
		county: {
			codeList: {_id: "county"}
		},
		city_plain: {
			field: "cityText"
		},
		obj_city: {
			relation: "@city"
		},
		street_plain: {
			field: "street"
		},
		house_number: {
			field: "house_number"
		},
		obj_zip: {
			relation: "@zip"
		},
		zip_plain: {
			field: "zipText"
		},
		specific_rel: {
			relation: "@specrel"
		},
		// type: {
		//   field: "type"
		// },
		type: {
			codeList: {_id: "type"}
		},
		description: {
			field: "description"
		}
		// type: {
		// 	object: {
		// 		descriptor: {
		// 			_id: "type"
		// 		}
		// 	}
		// }
		// type: "CA"
		// type: {
		//   codeList: { _id: "@type" }
		// }
		// county: {
		//   field: "county"
		// },
		// specific_rel: {
		//   relation: {
		//     _type: "Entity.Data.Client",
		//     _id: "#clientId"
		//   }
		// }
	}
}
